/**
 * @file step
 * @author zhaomiaoyuan
 */
import React from 'react';
import TextAreaFormItem from '../../components/TextAreaFormItem/index';
import UploadProof from '../../components/UploadProof/index';

import {
    feedbackTip
} from '../../components/UploadProof/uploadTip';
import {FEEDBACK_OTHER, FEEDBACK_SPEC} from './conf';
interface IFeedbackModalProps {
    updateAppeal: (value: any) => void;
    isFeedbackRequired?: boolean;
    maxLength?: number;
    textWidth?: string;
    appealData: {
        questionImg: [];
        questionType: number;
        questionContent: string;
        hasSearchUrl?: boolean;
        isRead?: boolean;
        phone?: string;
    }
}
export default function FeedbackModal(props: IFeedbackModalProps) {
    const {updateAppeal, appealData, isFeedbackRequired = false, maxLength, textWidth} = props;
    const {questionType} = appealData;

    return (<div>
        <TextAreaFormItem
            title="问题说明"
            isMsgRequired={questionType === FEEDBACK_OTHER || isFeedbackRequired}
            placeholder={FEEDBACK_SPEC.includes(questionType)
                ? '请详细说明问题，以便我们定位与解决。 \n如果是您号码被标记，请选择"号码占用申诉"进行申诉。'
                : '请详细说明问题，以便我们定位与解决。'
            }
            type="questionContent"
            maxLength={maxLength ? maxLength : 40}
            updateData={updateAppeal}
            data={appealData}
            style={{width: textWidth ? textWidth :'424px'}}
        />
        <UploadProof
            title="问题截图"
            isMsgRequired={false}
            type="questionImg"
            maxImgLength={1}
            data={appealData}
            updateData={updateAppeal}
            tips={feedbackTip()}
        />
    </div>);
}